import {Button, Divider, Input, message, Row, Col} from 'antd';
import {useState} from 'react';
import {insertVendor, setAddressForVendor, setEmailAddressForVendor, setPhoneNumberForVendor} from "../../api/Api";


export const NewVendorInput = ({onApiFail, onRefresh, props}) => {

    const [company, setCompany] = useState("");
    const [messageApi, contextHolder] = message.useMessage();

    // address state
    const [streetAddress, setStreetAddress] = useState("");
    const [streetAddressLine2, setStreetAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [addressDescription, setAddressDescription] = useState("");

    // email state
    const [email, setEmail] = useState("");
    const [emailDescription, setEmailDescription] = useState("");

    // phone number state
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneDescription, setPhoneDescription] = useState("");


    const onCompanyChange = (e) => {
        setCompany(e.target.value);
    }

    const onFail = (e) => {
        if (e.status === 401) {
            if (onApiFail) {
                onApiFail();
            }
        }
    }

    const onSubmit = () => {
        if (company === "") {
            return;
        }

        insertVendor(company).then(result => {
            const vendorId = result;
            if (streetAddress !== "") {
                setAddressForVendor(vendorId, streetAddress, streetAddressLine2, city, state, country, postalCode, addressDescription).then(r => {
                    console.log(`set address succeeded`);
                }).catch(e => {
                    console.log(`set address failed ${e}`)
                });
            }
            if (email !== "") {
                setEmailAddressForVendor(vendorId, email, emailDescription).then(r => {
                    console.log(`set email succeeded`);
                }).catch(e => {
                    console.log(`set email failed ${e}`)
                })
            }
            if (phoneNumber !== "") {
                setPhoneNumberForVendor(vendorId, phoneNumber, phoneDescription).then(r => {
                    console.log(`set phone number succeeded`);
                }).catch(e => {
                    console.log(`set phone number failed ${e}`)
                })
            }
            if (onRefresh) {
                onRefresh();
            }
            clearInputs();
            messageApi.open({
                type: 'success',
                content: 'Vendor Added Successfully',
            });
        }).catch(e => {
            onFail(e);
        })
    }

    const onStreetAddressChange = (e) => {
        setStreetAddress(e.target.value);
    }

    const onStreetAddressLine2Change = (e) => {
        setStreetAddressLine2(e.target.value);
    }

    const onCityChange = (e) => {
        setCity(e.target.value);
    }

    const onStateChange = (e) => {
        setState(e.target.value);
    }

    const onCountryChange = (e) => {
        setCountry(e.target.value);
    }

    const onPostalCodeChange = (e) => {
        setPostalCode(e.target.value);
    }

    const onAddressDescriptionChange = (e) => {
        setAddressDescription(e.target.value);
    }

    const onEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const onEmailDescriptionChange = (e) => {
        setEmailDescription(e.target.value);
    }

    const onPhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
    }

    const onPhoneDescriptionChange = (e) => {
        setPhoneDescription(e.target.value);
    }

    const clearInputs = () => {
        setCompany("");
        setStreetAddress("");
        setStreetAddressLine2("");
        setCity("");
        setState("");
        setCountry("");
        setPostalCode("");
        setAddressDescription("");
        setEmail("");
        setEmailDescription("");
        setPhoneNumber("");
        setPhoneDescription("");
    }


    const spanLength = 12;

    const submitDisabled = (company === null) || (company === "");

    return (
        <div>
            <div>{contextHolder}</div>
            <div >
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><div><Input onChange={onCompanyChange} placeholder={'Company'} value={company} /></div></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><div><Button onClick={onSubmit} disabled={submitDisabled}>Submit</Button></div></Col>
                </Row>
                <Divider orientation={'left'}>Address</Divider>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Street"} onChange={onStreetAddressChange} value={streetAddress}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Street2"} onChange={onStreetAddressLine2Change} value={streetAddressLine2}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"City"} onChange={onCityChange} value={city}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"State"} onChange={onStateChange} value={state}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Postal Code"} onChange={onPostalCodeChange} value={postalCode}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Country"} onChange={onCountryChange} value={country}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Description"} onChange={onAddressDescriptionChange} value={addressDescription}></Input></Col>
                </Row>
                <Divider orientation={'left'}>Email</Divider>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Email"} onChange={onEmailChange} value={email}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Email Description"} onChange={onEmailDescriptionChange} value={emailDescription}></Input></Col>
                </Row>
                <Divider orientation={'left'}>Phone</Divider>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Phone Number"} onChange={onPhoneNumberChange} value={phoneNumber}/></Col>
                </Row>
                <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col span={spanLength}><Input placeholder={"Phone Description"} onChange={onPhoneDescriptionChange} value={phoneDescription}></Input></Col>
                </Row>
                <Row>
                    <Col span={spanLength}><div><Button onClick={onSubmit} disabled={submitDisabled}>Submit</Button></div></Col>
                </Row>
            </div>
        </div>
    )
}